import type { MenuItem } from 'primevue/menuitem';

export default [
    {
        label: 'Access Control',
        icon: 'pi pi-users',
        items: [
            {
                label: 'Roles',
                icon: 'pi pi-id-card',
                to: '/roles',
            },
            {
                label: 'Teams',
                icon: 'pi pi-th-large',
                to: '/teams',
            },
            {
                label: 'Team Licenses',
                icon: 'pi pi-tag',
                to: '/licenses',
            },
        ],
    },
    {
        label: 'Company Management',
        icon: 'pi pi-building',
        items: [
            {
                label: 'Contacts',
                icon: 'pi pi-user',
                to: '/contacts',
            },
            {
                label: 'Companies',
                icon: 'pi pi-building',
                to: '/companies',
            },
        ],
    },
    {
        label: 'Maintenance',
        icon: 'pi pi-wrench',
        items: [
            {
                label: 'Maintenance',
                icon: 'pi pi-wrench',
                to: '/maintenance',
            },
        ],
    },
] satisfies MenuItem[];
